import {
  DataSettingPopupType,
  DataSettings,
  EDataSettingPointType,
  EDataSettingPopupType,
  EDataSettingSpatialType
} from "@/types/dataSetting";

const isNoneTypeSaveDisabled = (dataSetting: DataSettings): boolean => {
  if (!dataSetting.spatialAggregation?.type?.value) return true;

  const spatialType = dataSetting.spatialAggregation.type.value;

  if (spatialType === EDataSettingSpatialType.Admin_Area)
    return !dataSetting.spatialAggregation.adminAreaAttribute;

  if (spatialType === EDataSettingSpatialType.Point) {
    if (!dataSetting.spatialAggregation.point?.pointType?.value) return true;

    const pointType = dataSetting.spatialAggregation.point.pointType.value;

    if (pointType === EDataSettingPointType.Coordinate)
      return (
        !dataSetting.spatialAggregation.point.pointCoordinate?.latAttribute ||
        !dataSetting.spatialAggregation.point.pointCoordinate?.longAttribute
      );

    if (pointType === EDataSettingPointType.Geocoding)
      return !dataSetting.spatialAggregation.point.geocodingAtrtribute;
  }

  return false;
};

const isMultipleTypeSaveDisabled = (dataSetting: DataSettings): boolean => {
  if (!dataSetting.spatialAggregation?.type?.value) return true;

  const { spatialAggregation } = dataSetting;

  switch (spatialAggregation.type?.value) {
    case EDataSettingSpatialType.Point:
      return !spatialAggregation.pointAttribute;
    case EDataSettingSpatialType.Polygon:
      return !spatialAggregation.polygonAttribute;
    case EDataSettingSpatialType.Line:
      return !spatialAggregation.lineAttribute;
    case EDataSettingSpatialType.H3:
      return !spatialAggregation.h3Attribute;
    case EDataSettingSpatialType.Geohash:
      return !spatialAggregation.geohashAttribute;
    case EDataSettingSpatialType.Admin_Area:
      return !spatialAggregation.adminAreaAttribute;
    default:
      return false;
  }
};

/** Shared by the current Data Settings popup and the ADM Area Mapping one behind
 * `isAdmAreaForUserDataEnabled`, so both gate Save on the same rules. */
export const isSaveDataSettingDisabled = (
  type: DataSettingPopupType,
  dataSetting: DataSettings | null
): boolean => {
  if (!dataSetting?.country) {
    return true;
  }
  switch (type) {
    case EDataSettingPopupType.None:
      return isNoneTypeSaveDisabled(dataSetting);
    case EDataSettingPopupType.Single:
      return false;
    case EDataSettingPopupType.Multiple:
      return isMultipleTypeSaveDisabled(dataSetting);
    default:
      return true;
  }
};
